export default __webpack_public_path__ + "static/apercu-regular-8d6833d6b8501ce1cdb7bc8d992f4d9c.eot";